/**
 * ============================================
 * ARQUIVO DE USUARIOS DE TESTE
 * ============================================
 * APENAS PARA DESENVOLVIMENTO/TESTES
 * DESABILITADO AUTOMATICAMENTE EM PRODUCAO
 * CRITICO PARA SEGURANCA
 */
/**
 * ============================================
 * ARQUIVO DE USUÁRIOS DE TESTE
 * ============================================
 * 
 * ⚠️ APENAS PARA DESENVOLVIMENTO/TESTES
 * 🔒 DESABILITADO AUTOMATICAMENTE EM PRODUÇÃO
 * 
 * 🚨 SEGURANÇA:
 * - Em produção (NODE_ENV === 'production'), TEST_USERS retorna {}
 * - Apenas Firebase Auth é válido em produção
 * - Emails @test.com são bloqueados em prod
 * 
 * 📝 DOCUMENTAÇÃO COMPLETA: ver TEST_USERS.md
 */

import { Role, RegionalId, VendorStatus, UserStatus } from '../types';


export interface TestUser {
  password: string;
  role: Role;
  userId: string;
  name: string;
  regionalId?: RegionalId;
  vendorStatus?: VendorStatus;
  userStatus?: UserStatus;
}

const DEV_TEST_USERS: Record<string, TestUser> = {
  
  // ===== SUPER ADMIN (ACESSO TOTAL AO SISTEMA) =====
  "admin@test.com": {
    password: "123456",
    role: "SUPER_ADMIN",
    userId: "admin_test_01",
    name: "Administrador Sistema",
    userStatus: "active"
  },

  // ===== OWNER (DONO/GESTOR GERAL DO APP) =====
  "owner@test.com": {
    password: "123456",
    role: "OWNER",
    userId: "owner_test_01",
    name: "Gestor Geral - Proprietário",
    userStatus: "active"
  },
  "gestor@eambulante.com": {
    password: "123456",
    role: "OWNER",
    userId: "owner_test_02",
    name: "Carlos Eduardo - CEO",
    userStatus: "active"
  },

  // ===== FISCAIS POR REGIONAL (5 fiscais × 12 regionais = 60 fiscais) =====
  // Regional 1
  "fiscal.r1.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r1_01", name: "João Silva - Fiscal R1", regionalId: "Regional 1", userStatus: "active" },
  "fiscal.r1.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r1_02", name: "Maria Santos - Fiscal R1", regionalId: "Regional 1", userStatus: "active" },
  "fiscal.r1.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r1_03", name: "Pedro Costa - Fiscal R1", regionalId: "Regional 1", userStatus: "active" },
  "fiscal.r1.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r1_04", name: "Ana Lima - Fiscal R1", regionalId: "Regional 1", userStatus: "active" },
  "fiscal.r1.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r1_05", name: "Carlos Mendes - Fiscal R1", regionalId: "Regional 1", userStatus: "active" },
  
  // Regional 2
  "fiscal.r2.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r2_01", name: "Roberto Alves - Fiscal R2", regionalId: "Regional 2", userStatus: "active" },
  "fiscal.r2.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r2_02", name: "Juliana Souza - Fiscal R2", regionalId: "Regional 2", userStatus: "active" },
  "fiscal.r2.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r2_03", name: "Fernando Dias - Fiscal R2", regionalId: "Regional 2", userStatus: "active" },
  "fiscal.r2.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r2_04", name: "Camila Rocha - Fiscal R2", regionalId: "Regional 2", userStatus: "active" },
  "fiscal.r2.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r2_05", name: "Lucas Ferreira - Fiscal R2", regionalId: "Regional 2", userStatus: "active" },
  
  // Regional 3
  "fiscal.r3.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r3_01", name: "Mariana Gomes - Fiscal R3", regionalId: "Regional 3", userStatus: "active" },
  "fiscal.r3.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r3_02", name: "Diego Oliveira - Fiscal R3", regionalId: "Regional 3", userStatus: "active" },
  "fiscal.r3.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r3_03", name: "Beatriz Martins - Fiscal R3", regionalId: "Regional 3", userStatus: "active" },
  "fiscal.r3.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r3_04", name: "Rafael Silva - Fiscal R3", regionalId: "Regional 3", userStatus: "active" },
  "fiscal.r3.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r3_05", name: "Larissa Ribeiro - Fiscal R3", regionalId: "Regional 3", userStatus: "active" },
  
  // Regional 4
  "fiscal.r4.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r4_01", name: "Thiago Araújo - Fiscal R4", regionalId: "Regional 4", userStatus: "active" },
  "fiscal.r4.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r4_02", name: "Vanessa Cardoso - Fiscal R4", regionalId: "Regional 4", userStatus: "active" },
  "fiscal.r4.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r4_03", name: "Gustavo Pereira - Fiscal R4", regionalId: "Regional 4", userStatus: "active" },
  "fiscal.r4.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r4_04", name: "Patricia Barbosa - Fiscal R4", regionalId: "Regional 4", userStatus: "active" },
  "fiscal.r4.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r4_05", name: "Bruno Moreira - Fiscal R4", regionalId: "Regional 4", userStatus: "active" },
  
  // Regional 5
  "fiscal.r5.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r5_01", name: "Gabriela Sousa - Fiscal R5", regionalId: "Regional 5", userStatus: "active" },
  "fiscal.r5.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r5_02", name: "Rodrigo Teixeira - Fiscal R5", regionalId: "Regional 5", userStatus: "active" },
  "fiscal.r5.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r5_03", name: "Amanda Freitas - Fiscal R5", regionalId: "Regional 5", userStatus: "active" },
  "fiscal.r5.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r5_04", name: "Vinicius Cruz - Fiscal R5", regionalId: "Regional 5", userStatus: "active" },
  "fiscal.r5.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r5_05", name: "Isabela Ramos - Fiscal R5", regionalId: "Regional 5", userStatus: "active" },
  
  // Regional 6
  "fiscal.r6.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r6_01", name: "Eduardo Lopes - Fiscal R6", regionalId: "Regional 6", userStatus: "active" },
  "fiscal.r6.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r6_02", name: "Natália Moura - Fiscal R6", regionalId: "Regional 6", userStatus: "active" },
  "fiscal.r6.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r6_03", name: "Henrique Pinto - Fiscal R6", regionalId: "Regional 6", userStatus: "active" },
  "fiscal.r6.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r6_04", name: "Daniela Correia - Fiscal R6", regionalId: "Regional 6", userStatus: "active" },
  "fiscal.r6.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r6_05", name: "Felipe Gonçalves - Fiscal R6", regionalId: "Regional 6", userStatus: "active" },
  
  // Regional 7
  "fiscal.r7.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r7_01", name: "Renata Azevedo - Fiscal R7", regionalId: "Regional 7", userStatus: "active" },
  "fiscal.r7.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r7_02", name: "Leandro Batista - Fiscal R7", regionalId: "Regional 7", userStatus: "active" },
  "fiscal.r7.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r7_03", name: "Tatiana Nogueira - Fiscal R7", regionalId: "Regional 7", userStatus: "active" },
  "fiscal.r7.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r7_04", name: "Alexandre Farias - Fiscal R7", regionalId: "Regional 7", userStatus: "active" },
  "fiscal.r7.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r7_05", name: "Priscila Monteiro - Fiscal R7", regionalId: "Regional 7", userStatus: "active" },
  
  // Regional 8
  "fiscal.r8.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r8_01", name: "Marcelo Duarte - Fiscal R8", regionalId: "Regional 8", userStatus: "active" },
  "fiscal.r8.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r8_02", name: "Aline Castro - Fiscal R8", regionalId: "Regional 8", userStatus: "active" },
  "fiscal.r8.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r8_03", name: "Fábio Andrade - Fiscal R8", regionalId: "Regional 8", userStatus: "active" },
  "fiscal.r8.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r8_04", name: "Luciana Pires - Fiscal R8", regionalId: "Regional 8", userStatus: "active" },
  "fiscal.r8.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r8_05", name: "Márcio Cavalcante - Fiscal R8", regionalId: "Regional 8", userStatus: "active" },
  
  // Regional 9
  "fiscal.r9.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r9_01", name: "Cristina Vieira - Fiscal R9", regionalId: "Regional 9", userStatus: "active" },
  "fiscal.r9.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r9_02", name: "Anderson Neves - Fiscal R9", regionalId: "Regional 9", userStatus: "active" },
  "fiscal.r9.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r9_03", name: "Simone Macedo - Fiscal R9", regionalId: "Regional 9", userStatus: "active" },
  "fiscal.r9.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r9_04", name: "Ricardo Cunha - Fiscal R9", regionalId: "Regional 9", userStatus: "active" },
  "fiscal.r9.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r9_05", name: "Eliane Santiago - Fiscal R9", regionalId: "Regional 9", userStatus: "active" },
  
  // Regional 10
  "fiscal.r10.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r10_01", name: "Paulo Miranda - Fiscal R10", regionalId: "Regional 10", userStatus: "active" },
  "fiscal.r10.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r10_02", name: "Mônica Campos - Fiscal R10", regionalId: "Regional 10", userStatus: "active" },
  "fiscal.r10.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r10_03", name: "Sérgio Tavares - Fiscal R10", regionalId: "Regional 10", userStatus: "active" },
  "fiscal.r10.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r10_04", name: "Carla Rezende - Fiscal R10", regionalId: "Regional 10", userStatus: "active" },
  "fiscal.r10.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r10_05", name: "Jorge Borges - Fiscal R10", regionalId: "Regional 10", userStatus: "active" },
  
  // Regional 11
  "fiscal.r11.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r11_01", name: "Silvia Melo - Fiscal R11", regionalId: "Regional 11", userStatus: "active" },
  "fiscal.r11.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r11_02", name: "Antônio Pacheco - Fiscal R11", regionalId: "Regional 11", userStatus: "active" },
  "fiscal.r11.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r11_03", name: "Raquel Lemos - Fiscal R11", regionalId: "Regional 11", userStatus: "active" },
  "fiscal.r11.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r11_04", name: "César Barreto - Fiscal R11", regionalId: "Regional 11", userStatus: "active" },
  "fiscal.r11.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r11_05", name: "Adriana Fonseca - Fiscal R11", regionalId: "Regional 11", userStatus: "active" },
  
  // Regional 12
  "fiscal.r12.01@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r12_01", name: "Wellington Braga - Fiscal R12", regionalId: "Regional 12", userStatus: "active" },
  "fiscal.r12.02@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r12_02", name: "Fernanda Rego - Fiscal R12", regionalId: "Regional 12", userStatus: "active" },
  "fiscal.r12.03@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r12_03", name: "Júlio Xavier - Fiscal R12", regionalId: "Regional 12", userStatus: "active" },
  "fiscal.r12.04@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r12_04", name: "Sônia Viana - Fiscal R12", regionalId: "Regional 12", userStatus: "active" },
  "fiscal.r12.05@test.com": { password: "123456", role: "CITY_HALL", userId: "fiscal_r12_05", name: "Maurício Leal - Fiscal R12", regionalId: "Regional 12", userStatus: "active" },

  // ===== VENDEDORES REGULAMENTADOS (para testar aprovação e chat com fiscal) =====
  "vendedor.r1@test.com": {
    password: "123456",
    role: "VENDOR",
    userId: "vendor_r1_01",
    name: "José Tapioqueiro",
    regionalId: "Regional 1",
    vendorStatus: "REGULATED",
    userStatus: "active"
  },
  "vendedor.r2@test.com": {
    password: "123456",
    role: "VENDOR",
    userId: "vendor_r2_01",
    name: "Ana das Águas",
    regionalId: "Regional 2",
    vendorStatus: "REGULATED",
    userStatus: "active"
  },

  // ===== VENDEDOR REGULAMENTADO - REGIONAL 5 =====
  "vendedor.r5@test.com": {
    password: "123456",
    role: "VENDOR",
    userId: "vendor_r5_01",
    name: "Maria dos Pastéis",
    regionalId: "Regional 5",
    vendorStatus: "REGULATED",
    userStatus: "active"
  },

  // ===== VENDEDOR PENDENTE (para testar fluxo de aprovação) =====
  "vendedor.pendente@test.com": {
    password: "123456",
    role: "VENDOR",
    userId: "vendor_pending_01",
    name: "Pedro Aguardando Aprovação",
    regionalId: "Regional 1",
    vendorStatus: "PENDING_VERIFICATION",
    userStatus: "active"
  },

  // ===== VENDEDOR LIVRE (empreendedor autônomo, sem regional) =====
  "vendedor.livre@test.com": {
    password: "123456",
    role: "VENDOR",
    userId: "vendor_unreg_01",
    name: "Lucas Vendedor Livre",
    vendorStatus: "UNREGULATED",
    userStatus: "active"
  },

  // ===== MOTORISTAS (para testar entregas) =====
  "jeferson@gmail.com": {
    password: "123456",
    role: "DRIVER",
    userId: "driver_jeferson_01",
    name: "Jeferson - Motoboy",
    userStatus: "active"
  },
  "moto1@test.com": {
    password: "123456",
    role: "DRIVER",
    userId: "driver_moto_01",
    name: "Carlos Delivery - Moto",
    userStatus: "active"
  },
  "moto2@test.com": {
    password: "123456",
    role: "DRIVER",
    userId: "driver_moto_02",
    name: "Rafael Entregas - Moto",
    userStatus: "active"
  },
  "carro@test.com": {
    password: "123456",
    role: "DRIVER",
    userId: "driver_car_01",
    name: "Marcos Entregas - Carro",
    userStatus: "active"
  },

  // ===== CLIENTES (para testar fluxo de compra) =====
  "cliente1@test.com": {
    password: "123456",
    role: "CLIENT",
    userId: "client_01",
    name: "Fernanda Costa - Cliente",
    userStatus: "active"
  },
  "cliente2@test.com": {
    password: "123456",
    role: "CLIENT",
    userId: "client_02",
    name: "Roberto Oliveira - Cliente",
    userStatus: "active"
  },

  // ===== FORNECEDORES (para testar B2B) =====
  "fornecedor.gelo@test.com": {
    password: "123456",
    role: "SUPPLIER",
    userId: "supplier_gelo_01",
    name: "Gelo do Norte Distribuidora",
    userStatus: "active"
  },
  "fornecedor.bebidas@test.com": {
    password: "123456",
    role: "SUPPLIER",
    userId: "supplier_bebidas_01",
    name: "Bebidas Express LTDA",
    userStatus: "active"
  }
};

export interface ValidatedUser {
  role: Role;
  userId: string;
  name: string;
  regionalId?: RegionalId;
  vendorStatus?: VendorStatus;
  userStatus?: UserStatus;
}

/**
 * Função para validar credenciais (sem exposição de senhas)
 * Nunca retorna a senha, apenas confirma se está correta
 */
export function validateCredentials(email: string, password: string): { isValid: boolean; user?: ValidatedUser; error?: string } {
  const user = TEST_USERS[email.toLowerCase().trim()];

  if (!user) {
    return { isValid: false, error: "Usuário não encontrado" };
  }

  if (user.password !== password) {
    return { isValid: false, error: "Senha incorreta" };
  }

  // Retorna usuário SEM a senha, COM regionalId e status
  return { 
    isValid: true, 
    user: {
      role: user.role,
      userId: user.userId,
      name: user.name,
      regionalId: user.regionalId,
      vendorStatus: user.vendorStatus,
      userStatus: user.userStatus || 'active'
    }
  }
};

// ============================================
// 🔒 EXPORTAÇÃO SEGURA - VAZIO EM PRODUÇÃO
// ============================================
// ✅ SEGURANÇA: Em produção, TEST_USERS é objeto vazio (bloqueado)
// Apenas Firebase Auth real é válido em produção
const IS_PRODUCTION = typeof import.meta !== 'undefined' && !!import.meta.env && !!import.meta.env.PROD;
export const TEST_USERS: Record<string, TestUser> = IS_PRODUCTION ? {} : DEV_TEST_USERS;

// Log de segurança
if (!IS_PRODUCTION) {
  console.log('?? [DEV] TEST_USERS habilitados para desenvolvimento');
} else {
  console.log('?? [PROD] TEST_USERS DESABILITADOS - Apenas Firebase Auth real');
}

/**
 * Verifica se email já existe nos usuários de teste
 * Em produção, sempre retorna false (nenhum test user existe)
 */
export function isEmailInTestUsers(email: string): boolean {
  if (IS_PRODUCTION) return false;
  return DEV_TEST_USERS.hasOwnProperty(email.toLowerCase().trim());
}

